import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { caixaApi } from './api';
import type { MovimentoTipo } from './types';

export function useCaixaAtual() {
  return useQuery({
    queryKey: ['caixa', 'atual'],
    queryFn: () => caixaApi.atual(),
    staleTime: 10_000,
  });
}

export function useCaixaResumo(id: string | null | undefined) {
  return useQuery({
    queryKey: ['caixa', 'resumo', id],
    queryFn: () => caixaApi.resumo(id as string),
    enabled: !!id,
    refetchInterval: 20_000,
  });
}

export function useAbrirCaixa() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { valor_abertura: number; observacao?: string }) =>
      caixaApi.abrir(body),
    onSuccess: () => {
      toast.success('Caixa aberto');
      qc.invalidateQueries({ queryKey: ['caixa'] });
    },
    onError: (err: Error) => toast.error(err.message),
  });
}

export function useFecharCaixa() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { valor_informado: number; observacao?: string }) =>
      caixaApi.fechar(body),
    onSuccess: () => {
      toast.success('Caixa fechado');
      qc.invalidateQueries({ queryKey: ['caixa'] });
    },
    onError: (err: Error) => toast.error(err.message),
  });
}

export function useMovimentoCaixa() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { tipo: MovimentoTipo; valor: number; motivo?: string }) =>
      caixaApi.movimento(body),
    onSuccess: (_, variables) => {
      toast.success(variables.tipo === 'sangria' ? 'Sangria registrada' : 'Reforco registrado');
      qc.invalidateQueries({ queryKey: ['caixa'] });
    },
    onError: (err: Error) => toast.error(err.message),
  });
}
